<template>
  <div>
    <Header></Header>
    <main id="content" role="main">
      <!-- Hero Section -->
      <div class="position-relative bg-img-hero" style="background-size:100%">
        <div class="container space-2 space-md-3 space-bottom-lg-4 min-h-300rem" style="pos">
          <div class="d-none d-md-block" style="text-align: center;">
            <h1 style="color:#fff">客户案例</h1>
            <!-- text-primary -->
            <h2 class="h2" style="color:#fff">携手企业开展系统集成/数据可视化服务</h2>
          </div>
        </div>
        <div id="3dwg" style="position: absolute;bottom: -6px;width:100%"></div>
        <!-- SVG Background -->
        <!-- <figure class="position-absolute right-0 bottom-0 left-0">
          <svg
            preserveAspectRatio="none"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 1920 100.1"
          >
            <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z" />
          </svg>
        </figure> -->
        <!-- End SVG Background -->
      </div>
      <!-- End Hero Section -->

      <!-- Stories Section -->
      <div class="container space-2 space-lg-2">
        <!-- Title -->
        <div class="w-md-100 w-lg-50 text-center mx-md-auto mb-5 mb-md-9">
          <span class="d-block font-weight-bold text-cap mb-2">部分案例展示</span>
          <h2>用户为本，携手共进</h2>
        </div>
        <!-- End Title -->

        <div class="row">
          <div class="col-sm-6 col-md-4 mb-5" v-for="item in caselist" :key="item.contentId">
            <!-- Card Info -->
            <div class="card h-100" style="cursor:pointer" @click="skipDetail(item.contentId)">
              <img class="card-img-top" :src="getImgUrl(item.big)" alt="Image Description" />
              <div class="card-body">
                <div class="max-w-13rem w-100 mb-3">
                  <img class="img-fluid" :src="getImgUrl(item.small)" alt="Logo" />
                </div>
                <p class="mb-0">
                  {{item.subtitle}}
                </p>
              </div>
              <div class="card-footer">
                <span class="font-weight-bold" style="cursor:pointer;color:#0052ea">案例详情 <i class="fas fa-angle-right fa-sm ml-1"></i></span>
              </div>
            </div>
            <!-- End Card Info -->
          </div>
        </div>
        <div class="text-center mt-5">
          <button v-if="showBtn" class="btn btn-primary" @click="getMoreContentCase">查看更多案例</button>
          <p v-else>没有更多案例了</p>
        </div>
      </div>
      <!-- End Stories Section -->

      <!-- CTA Section -->
      <div class="bg-primary text-center bg-img-hero1">
        <div class="container space-2">
          <div class="mb-5">
            <h3 class="h2 text-white">索取更多案例/解决方案请与商务经理联系</h3>
          </div>
          <router-link class="btn btn-light transition-3d-hover" to="/contact">联系我们</router-link>
        </div>
      </div>
      <!-- End CTA Section -->
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/vendor/jquery/dist/jquery.min.js"; //1
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js"; //2

import "@/assets/vendor/font-awesome/css/all.min.css"; //12
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css"; //13
import "@/assets/css/theme.css"; //14
import "@/assets/vendor/hs-header/dist/hs-header.min.js"; //4
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js"; //5
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js"; //6
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js"; //7
import "@/assets/vendor/hs-show-animation/dist/hs-show-animation.min.js"; //8
import "@/assets/vendor/jquery-validation/dist/jquery.validate.min.js"; //9
import AOS from "aos";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; //3
import "@/assets/js/hs.core.js"; //10
import "@/assets/js/hs.validation.js"; //11
import Header from "@/components/header";
import Footer from "@/components/footer";
import { getsy, getsycolumn, getsyres } from "../request/index";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      caselist: [],
      page: 0,
      size: 6,
      showBtn: true,
      columnId: null
    };
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    $(document).ready(function () {
      console.log("aaa");
      //   console.log("ccccc",HSHeader)
      //   var header = new HSHeader($("#header")).init();
      console.log("bbb");

      // initialization of mega menu
      var megaMenu = new HSMegaMenu($(".js-mega-menu"), {
        desktop: {
          position: "left",
        },
      }).init();

      // initialization of unfold
      var unfold = new HSUnfold(".js-hs-unfold-invoker").init();

      // initialization of fancybox
      $(".js-fancybox").each(function () {
        var fancybox = $.HSCore.components.HSFancyBox.init($(this));
      });

      // initialization of circles
      $(".js-circle").each(function () {
        var circle = $.HSCore.components.HSCircles.init($(this));
      });

      //initialization of aos
      AOS.init({
        duration: 650,
        once: true,
      });
      // if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) document.write('<script src="@/assets/vendor/polifills.js"><\/script>');
      // initialization of go to
      $(".js-go-to").each(function () {
        var goTo = new HSGoTo($(this)).init();
      });
      $(".js-counter").each(function () {
        var counter = new HSCounter($(this)).init();
      });
    });
    this.get3Dgrid()
  },
  created() {
    this.getFirst()
  },
  methods: {
    // 3d网格线
    get3Dgrid() {
      var renderer = new THREE.WebGLRenderer({
        antialias: true
      });
      let container = document.getElementById("3dwg") //放3d图形的容器
      console.log("d",container.offsetWidth)
      /* Fullscreen */
      let innerWidth =container.offsetWidth
      let innerHeight =442
      renderer.setSize(innerWidth,innerHeight);
      /* Append to HTML */
      
      container.appendChild(renderer.domElement);
      var onRenderFcts = [];
      var scene = new THREE.Scene();
      var camera = new THREE.PerspectiveCamera(35, innerWidth / innerHeight, 0.01, 1000);
      /* Play around with camera positioning */
      camera.position.z = 15;
      camera.position.y = 2;
      /* Fog provides depth to the landscape*/
      scene.fog = new THREE.Fog(0x6495ED, 0, 45); // THREE.Fog 雾化效果
      ; (function () {
        // new THREE.AmbientLight(0x202020) 设置光源
        var light = new THREE.AmbientLight(0x202020)
        scene.add(light)
        var light = new THREE.DirectionalLight('white', 5)
        light.position.set(0.5, 0.0, 2)
        scene.add(light)
        var light = new THREE.DirectionalLight('white', 0.75 * 2)
        light.position.set(-0.5, -0.5, -2)
        scene.add(light)
      })()
      var heightMap = THREEx.Terrain.allocateHeightMap(256, 256)
      THREEx.Terrain.simplexHeightMap(heightMap)
      var geometry = THREEx.Terrain.heightMapToPlaneGeometry(heightMap)
      THREEx.Terrain.heightMapToVertexColor(heightMap, geometry)
      /* Wireframe built-in color is white, no need to change that */
      var material = new THREE.MeshBasicMaterial({
        wireframe: true
      });
      var mesh = new THREE.Mesh(geometry, material);
      scene.add(mesh);
      mesh.lookAt(new THREE.Vector3(0, 1, 0));
      /* Play around with the scaling */
      mesh.scale.y = 3.5;
      mesh.scale.x = 3;
      mesh.scale.z = 0.20;
      mesh.scale.multiplyScalar(10);
      /* Play around with the camera */
      onRenderFcts.push(function (delta, now) {
        mesh.rotation.z += 0.2 * delta;
      })
      onRenderFcts.push(function () {
        renderer.render(scene, camera);
      })
      var lastTimeMsec = null
      requestAnimationFrame(function animate(nowMsec) {
        requestAnimationFrame(animate);
        lastTimeMsec = lastTimeMsec || nowMsec - 1000 / 60
        var deltaMsec = Math.min(200, nowMsec - lastTimeMsec)
        lastTimeMsec = nowMsec
        onRenderFcts.forEach(function (onRenderFct) {
          onRenderFct(deltaMsec / 1000, nowMsec / 1000)
        })
      })
    },
    // 获取当前栏目
    getFirst() {
      getsycolumn(0).then(res => {
        let arr = res.data;
        arr.forEach(item => {
          if (item.title == "客户案例") {
            getsycolumn(item.columnId).then(hs => {
              let arr1 = hs.data
              this.colNum = hs.data
              arr1.forEach(ts => {
                if (ts.type == "用户为本，携手共进") { this.columnId = ts.columnId; this.getContent(ts.columnId) }
              })
            })
          }
        })
      })
    },
    // 获取内容
    getContent(id) {
      getsy(id, { page: this.page, size: this.size }).then(res => {
        if (res.data.content.length > 0) {
          let arr = res.data.content
          arr.forEach((item, index) => {
            item.showImgStatu = false
            this.getSource(item, item.contentId, index, arr)
          })
        } else {
          this.showBtn = false
        }

      })
    },
    // 获取内容资源资源
    getSource(obj, id, index, array) {
      getsyres(id).then(res => {
        let arr = res.data
        console.log(arr)
        if (arr && arr.length > 0) {
          arr.forEach(hs => { obj[hs.keystring] = hs.fileId })
        }
        this.caselist.push(obj)
        this.caselist.sort((a, b) => { return a.tag - b.tag })
      })
    },
    // 图片地址
    getImgUrl(id) {
      return process.env.NODE_URL + "api/files/getFileStream?fileId=" + id
    },
    // 跳转详情
    skipDetail(id) {
      this.$router.push({ path: '/casedetail', query: { id: id } })
    },
    getMoreContentCase() {
      this.page = this.page + 1
      this.getContent(this.columnId)
    }
  }
};
</script>

<style scoped>
.bg-img-hero {
  /* background: url("../assets/img/1920x1080/img6.jpg") no-repeat; */
  background: #377dff;
}
.bg-img-hero1 {
  background: url("../assets/svg/components/abstract-shapes-5.svg") center;
}
svg {
  margin-bottom: -16px;
}
.d-none h1 {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.d-none h2,
.w-md-100 h2 {
  font-size: 1.875rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.w-md-100 span {
  font-size: 1rem;
  line-height: 1.6;
  color: #677788;
}
.mb-0 {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
  text-align: left;
}
a {
  text-decoration: none;
}
.btn {
  display: inline-block;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  border: 0.0625rem solid transparent;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  line-height: 1.6;
  border-radius: 0.3125rem;
  transition: all 0.2s ease-in-out;
}
</style>


// WEBPACK FOOTER //
// src/view/case.vue